function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import PropTypes from 'prop-types';
import ApplicationUnavailablePage from './ApplicationUnavailablePage';
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "resetError", () => {
      this.setState({
        hasError: false
      });
    });
    this.state = {
      hasError: false
    };
  }
  static getDerivedStateFromError() {
    return {
      hasError: true
    };
  }
  componentDidCatch(error, errorInfo) {
    // Log to observability service
    console.error('ErrorBoundary caught error:', error, errorInfo);
  }
  render() {
    const {
      hasError
    } = this.state;
    const {
      children
    } = this.props;
    if (hasError) {
      return /*#__PURE__*/React.createElement(ApplicationUnavailablePage, {
        onRetry: this.resetError
      });
    }
    return children;
  }
}
export default ErrorBoundary;